import {View, Sync} from 'MWC';
import React from 'react';
import Collection from '../collections/main.cll.js';
import CollectionBusiness from '../collections/business.cll';
import {apiback} from '../../../config';
import {canUseDOM} from '../../../helpers/canUseDOM';

const BUSINESS_RATE_TYPE_ID = '8'; // USD/EUR для бізнесу
const APP_RATE_TYPE_ID = '18'; // мобільний додаток

export default class extends View {
    constructor() {
        super();

        this.branchCourses = new Collection();
        this.nbuCourses = new Collection();
        this.processingCourses = new Collection();
        this.businessCourses = new CollectionBusiness();
        this.appCourses = new CollectionBusiness();
    }

    render() {
        const Component = this.props.component;

        if (!this.branchCourses.length) {
            return null;
        } else {
            return (
                <Component
                    {...this.props}
                    branchCourses={this.branchCourses}
                    nbuCourses={this.nbuCourses}
                    processingCourses={this.processingCourses}
                    businessCourses={this.businessCourses}
                    appCourses={this.appCourses}
                >
                    {this.props.children}
                </Component>
            );
        }
    }

    componentWillMount() {
        if (canUseDOM) return;
        const {ssrData} = this.props;
        if (!ssrData) return;
        const {exchangeRates, exchangeBusinessRates} = ssrData;
        if (exchangeRates) {
            this.branchCourses.reset(exchangeRates.data, {parse: true});
            this.nbuCourses.reset(exchangeRates.nbu, {parse: true});
            this.processingCourses.reset(exchangeRates.processing, {parse: true});
        }
        if (exchangeBusinessRates) {
            this.businessCourses.reset(
                exchangeBusinessRates.data && exchangeBusinessRates.data[BUSINESS_RATE_TYPE_ID],
                {parse: true}
            );
            this.appCourses.reset(
                exchangeBusinessRates.data && exchangeBusinessRates.data[APP_RATE_TYPE_ID],
                {
                    parse: true
                }
            );
        }
    }

    componentWillReady = async resolve => {
        try {
            await this.load();
            return resolve();
        } catch (error) {
            return resolve();
        }
    };

    createRateRequest = key => {
        const Engine = Sync.getEngine('xhr');
        return new Engine({
            url: apiback(key),
            type: 'GET',
            dataType: 'json',
            cache: false
        });
    };

    load = async () => {
        const xhr = this.createRateRequest('API_RATES');
        const xhrBusiness = this.createRateRequest('API_BUSINESS_RATES');

        try {
            const response = await xhr.get();
            const responseBusiness = await xhrBusiness.get();

            this.branchCourses.reset(response.data, {parse: true});
            this.nbuCourses.reset(response.nbu, {parse: true});
            this.processingCourses.reset(response.processing, {parse: true});
            this.businessCourses.reset(responseBusiness.data[BUSINESS_RATE_TYPE_ID], {parse: true});
            this.appCourses.reset(responseBusiness.data[APP_RATE_TYPE_ID], {parse: true});
        } catch (error) {
            return error;
        }
    };

    static displayName = 'ExchangeRates.Views.Main';
}
